import axios from "axios";
import { HOST_API_KEY } from "../../config";
import { axiosInstanceWithToken } from "../utils/axios";

export const postCommentsLikes = async (data) => {
  const response = await axiosInstanceWithToken.post(HOST_API_KEY + "/posts/commentLike", data);
  return response?.data;
};

export const postCommentsDislikes = async (data) => {
  const response = await axiosInstanceWithToken.post(HOST_API_KEY + "/posts/commentDislike", data);
  return response?.data;
};

export const deletePostComment = async (commentId) => {
  const response = await axiosInstanceWithToken.delete(HOST_API_KEY + "/comments/" + commentId);
  return response;
};

export const createPostComment = async (postId, data) => {
  const response = await axiosInstanceWithToken.post(HOST_API_KEY + "/posts/" + postId + "/comment", data);
  return response?.data;
};

export const postCommentMediaUpload = async (commentId, data) => {
  const response = await axiosInstanceWithToken.post(
    HOST_API_KEY + "/posts/" + commentId + "/comment/media",
    data
  );
  return response?.data;
};
